import { Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";
import { IconButton } from "../buttons/material/iconButton/IconButton";
import { KeyboardArrowDown } from "@mui/icons-material";

interface QAItemProps extends React.ComponentProps<"p"> {
  question: string;
}

export const QAItem = ({ question, children }: QAItemProps) => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );
  const [showAnswer, setShowAnswer] = useState(false);

  const showAnswerHandler = () => {
    setShowAnswer((prev) => !prev);
  };

  return (
    <div
      onClick={showAnswerHandler}
      className={`py-5 cursor-pointer ${showAnswer ? "space-y-4" : ""}`}
      style={{
        borderBottom: "1px solid",
        borderBottomColor: componentColors.outline.outline,
      }}
    >
      <Stack direction={"row"} className="justify-between items-center">
        <Typography
          className="text-lg font-medium"
          sx={{ color: componentColors.surface.onSurface }}
        >
          {question}
        </Typography>

        <IconButton
          className="transition-all"
          icon={
            <KeyboardArrowDown
              className={`transition-all transform ${
                showAnswer ? "rotate-180" : ""
              }`}
            />
          }
        />
      </Stack>

      <Stack
        className={`${
          showAnswer ? "h-auto" : "h-0"
        } transition-all overflow-hidden `}
      >
        <Typography sx={{ color: componentColors.surface.onSurfaceVariant }}>
          {children}
        </Typography>
      </Stack>
    </div>
  );
};
